import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../../common/CCUtils"

export enum PhysicalAssets {

    BACKGROUND = "PhysicalBACKGROUND",
    FULL_DESK = "PhysicalFULL_DESK",
    DESK_2 = "PhysicalDESK_2",
    PHYSICAL_BRAIN = "PhysicalPHYSICAL_BRAIN",
    PHYSICAL_BRAIN_DARK = "PhysicalPHYSICAL_BRAIN_DARK",
    JUST_BRAIN = "PhysicalJUST_BRAIN",
    PA_TITLE = "PhysicalPA_TITLE",
    BUNSEN_LEFT = "PhysicalBUNSEN_LEFT",
    BUNSEN_RIGHT = "PhysicalBUNSEN_RIGHT",
    BEAKER = "PhysicalBEAKER",

    AUDIO = "PhysicalAUDIO",

    FROG = "PhysicalFROG",
    BUBBLES = "PhysicalBUBBLES",
    FLAME = "PhysicalFLAME",
    SCIENTIST_FROG = "PhysicalSCIENTIST_FROG",
}

export function loadAssets(game: Phaser.Game) {
    game.load.image(PhysicalAssets.BACKGROUND, CCUtils.asset("addiction/physical-addiction/background.png"))
    game.load.image(PhysicalAssets.FULL_DESK, CCUtils.asset("addiction/physical-addiction/full-desk.png"))
    game.load.image(PhysicalAssets.DESK_2, CCUtils.asset("addiction/physical-addiction/desk-2.png"))
    game.load.image(PhysicalAssets.PHYSICAL_BRAIN, CCUtils.asset("addiction/physical-addiction/physical-brain.png"))
    game.load.image(PhysicalAssets.PHYSICAL_BRAIN_DARK, CCUtils.asset("addiction/physical-addiction/physical-brain-dark.png"))
    game.load.image(PhysicalAssets.JUST_BRAIN, CCUtils.asset("addiction/physical-addiction/just-brain.png"))
    game.load.image(PhysicalAssets.PA_TITLE, CCUtils.asset("addiction/physical-addiction/pa-title.png"))
    game.load.image(PhysicalAssets.BUNSEN_LEFT, CCUtils.asset("addiction/physical-addiction/bunsen-left.png"))
    game.load.image(PhysicalAssets.BUNSEN_RIGHT, CCUtils.asset("addiction/physical-addiction/bunsen-right.png"))
    game.load.image(PhysicalAssets.BEAKER, CCUtils.asset("addiction/physical-addiction/beaker.png"))

    game.load.audio(PhysicalAssets.AUDIO, CCUtils.asset("addiction/physical-addiction/addiction-101-physical.mp3"))

    game.load.spritesheet(PhysicalAssets.FROG, CCUtils.asset("addiction/physical-addiction/frog.png"), 175, 100)
    game.load.spritesheet(PhysicalAssets.BUBBLES, CCUtils.asset("addiction/physical-addiction/bubbles.png"), 75, 46)
    game.load.spritesheet(PhysicalAssets.FLAME, CCUtils.asset("addiction/physical-addiction/flame.png"), 19, 32)
    game.load.spritesheet(PhysicalAssets.SCIENTIST_FROG,
        CCUtils.asset("addiction/physical-addiction/scientist-frog.png"), 357, 787)

}
